import { render, staticRenderFns } from "./athub-short-text.vue?vue&type=template&id=0ae3ad55&scoped=true&"
import script from "./athub-short-text.vue?vue&type=script&lang=js&"
export * from "./athub-short-text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae3ad55",
  null
  
)

export default component.exports